import { create } from "zustand";
import {
  DEFAULT_PRESET,
  findMatchingPreset,
  getPresetPeriod,
} from "../utils/period";
import type {
  AnalyticsPeriod,
  PeriodPresetKey,
  TrendTarget,
} from "../types/orderAnalytics.types";

interface OrderAnalyticsStore {
  period: AnalyticsPeriod;
  /** 강조할 프리셋. 날짜를 직접 고쳐 어느 프리셋과도 맞지 않으면 null */
  presetKey: PeriodPresetKey | null;
  trendTarget: TrendTarget | null;

  applyPreset: (key: PeriodPresetKey) => void;
  setPeriod: (period: AnalyticsPeriod) => void;
  openTrend: (target: TrendTarget) => void;
  closeTrend: () => void;
}

export const useOrderAnalyticsStore = create<OrderAnalyticsStore>((set) => ({
  period: getPresetPeriod(DEFAULT_PRESET),
  presetKey: DEFAULT_PRESET,
  trendTarget: null,

  applyPreset: (presetKey) =>
    set({ presetKey, period: getPresetPeriod(presetKey) }),
  setPeriod: (period) => set({ period, presetKey: findMatchingPreset(period) }),
  openTrend: (trendTarget) => set({ trendTarget }),
  closeTrend: () => set({ trendTarget: null }),
}));
